import axiosInstance from '@/core/js/interceptor';
import { AuthService } from '../AuthService';
export const UserService = {
    createOrUpdate: (data) => axiosInstance.post('/api/definition/user/CreateOrUpdate', data, { validateStatus: () => true }),
    getListByParams: (data) =>
        axiosInstance.post(
            '/api/definition/user/getListByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    delete: (data) => axiosInstance.post('/api/definition/user/delete', data, { validateStatus: () => true }),
    updatePassword: (data) => axiosInstance.post('/api/definition/user/updatePassword', data, { validateStatus: () => true })
};
